<template>
  <div class="fallback-confirmation flex flex-col items-start gap-2 text-sm">
    <BaseCheckbox v-model="fallbackTicked" :label="i18n.fallbackConfirmation" />
    <SecondaryButton
      :label="i18n.continueToV1"
      :is-disabled="!fallbackTicked"
      @click="onContinue"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import BaseCheckbox from '@/components/UI/Checkbox/BaseCheckbox.vue';
import SecondaryButton from '@/components/UI/Button/SecondaryButton.vue';
import { useDeprecationGateStore } from '@/store/deprecationGate/deprecationGateStore';
import { getDeprecationGateTexts } from '@/utils/deprecationGate/texts';

const props = defineProps<{
  v2LaunchAttempted: boolean;
  v2LaunchFailed: boolean;
}>();

const emit = defineEmits<{
  (e: 'continue-to-v1'): void;
}>();

const i18n = getDeprecationGateTexts();
const fallbackTicked = ref(false);

function onContinue() {
  if (!fallbackTicked.value) return;

  useDeprecationGateStore().confirmFallback({
    v2LaunchAttempted: props.v2LaunchAttempted,
    v2LaunchFailed: props.v2LaunchFailed,
  });
  emit('continue-to-v1');
}
</script>
